import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { Config } from "@/shared/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = Config.apiUrl;
  },

  setHeader() {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common.Authorization = token;
  },
  async post(resource, params) {
    ApiService.setHeader();
    let data = await axios.post(Config.apiUrl + `${resource}`, params);
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      window.location.href =  "/";
    }
    return data;
  },
  async get(resource, params) {
    ApiService.setHeader();
    let data = await axios.get(Config.apiUrl + `${resource}`, {
      params: params
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      window.location.href =  "/";
    }
    return data;
  },
  fileUpload(resource, params) {
    ApiService.setHeader();
    let data = axios.post(Config.apiUrl + `${resource}`, params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    if (_.get(data, "data.code", '') == "401" || _.get(data, "data.code", '') == "201") {
      window.location.href =  "/";
    }
    return data;
  }
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/apiservice.js